import { useConnectActionsHook } from "@/hooks/connectActions"

interface ErrorButtonsHookType {
  closeContactWithFallback: () => Promise<void>
}

const useErrorButtonsHook = (): ErrorButtonsHookType => {
  const { closeContact, closeTask } = useConnectActionsHook()

  const closeContactWithFallback = async () => {
    try {
      await closeContact()
    } catch {
      await closeTask()
    }
  }

  return {
    closeContactWithFallback,
  }
}

export { useErrorButtonsHook }
